<template>
  <section v-if="products.length" class="section">
    <div class="container-lg">
      <div class="section__header  mb-3">
        <h2 class="section__title">{{ in18['page_linked_products'] }}</h2>
      </div>

      <div class="variations-table">
        <div v-for="product in products" class="variations-table__row">
          <div class="variations-table__col">
            <div class="variations-table__data">
              <img :src="product.image.source"
                   :alt="product.title"
                   class="variations-table__image"
                   height="75"
                   width="75"
              >
              <div>
                <div class="variations-table__title">
                  {{ product.title }}
                  <div>{{ product.code }}</div>
                </div>
                <ul class="product__data  product__data--sm">
                  <li class="product_data-item" v-if="product.sizes">
                    {{ product.formatted_sizes }}
                  </li>
                  <li class="product_data-item" v-if="product.weight">
                    {{ product.formatted_weight }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="variations-table__col">
            <ul class="product__data">
              <li class="product_data-item">
                {{ in18['page_availability'] }}
                <span :class="['fw-500 no-wrap', stockStatusClass(product)]">
                    {{ stockStatusText(product) }}
                </span>
              </li>
            </ul>
          </div>

          <div class="variations-table__col">
            <product-price :prices="product.prices" :class-name="'variations-table__price'"/>
          </div>

          <div class="variations-table__col  text-right">
            <add-to-cart-button
                :product-id="product.id"
                :title="in18['page_add_to_cart']"
                :class="'btn  btn--icon  btn--green  btn--block'"
                :in18="in18"
            >
              <img alt="" src="/shop/images/add-to-cart.svg">
            </add-to-cart-button>
          </div>
        </div>
      </div><!-- /.variations-table -->
    </div><!-- /.container -->
  </section>
</template>

<script>
import AddToCartButton from "./AddToCartButton.vue";

export default {
  name:       "ProductRelatedManual",
  components: {
    'add-to-cart-button': AddToCartButton,
  },
  props:      [
    'products',
    'in18',
  ],
  methods:    {
    redirectToProduct(product) {
      window.location.href = product.link;
    },
    stockStatusText(product) {
      return product.is_available_for_purchase
          ? this.in18['page_product_in_stock']
          : this.in18['page_out_of_stock'];
    },
    stockStatusClass(product) {
      return product.is_available_for_purchase
          ? 'text-green'
          : 'text-primary';
    },
  },
}
</script>
